import { FC } from 'react';

const BitEmpty: FC = () => null;

export default BitEmpty;
